<template>
  <div>
    <base-header class="pb-6" type="">
        <b-row class="align-items-center py-4">
            <b-col lg="12" cols="12">
            <!-- <h6 class="h2 text-white d-inline-block mb-0">{{$route.name}}</h6> -->
                <h6 class="h2 d-inline-block mb-0">{{language_terms[$route.name]}}</h6>
                <nav aria-label="breadcrumb" class="d-none d-md-inline-block ml-md-4">
                    <route-breadcrumb/>
                </nav>
            </b-col>
        </b-row>
        </base-header>
        <div>
            <loading :active.sync="loading" 
              color= '#007bff'
              :width= '128'
              :height= '128'
              loader='dots'
              :can-cancel="true" 
              :is-full-page="true">
            </loading>
        </div>
        <b-container fluid class="mt--6">
            <card>
                <div slot="header">
                <b-row>
                    <b-col lg="6">
                        <h3 >{{language_terms['BASIC_INFORMATION']}} 
                        </h3>
                    </b-col>
                </b-row>
                </div>
                <b-row>
                    <b-col :lg="(isEmptyObj(selected_customer) ? false : ((selected_customer) ? true : false)) ? 4:8">
                        <label class="form-control-label">{{language_terms['CUSTOMER']}}</label>
                        <multiselect
                        autocomplete="off"
                            class="mt-1"
                            :custom-label="customerNameWithCode"
                            v-model="selected_customer"
                            placeholder="Type to search"
                            open-direction="bottom"
                            :options="report.customers"
                            :multiple="false"
                            :searchable="true"
                            :loading="loading"
                            :clear-on-select="false"
                            :close-on-select="true"
                            :options-limit="300"
                            :limit="50"
                            :max-height="600"
                            :show-no-results="false"
                            :hide-selected="true"
                            @search-change="asyncFindCustomer"
                            @select="onSelectCustomer">
                        </multiselect>
                    </b-col>
                    <b-col lg="4" v-if="(isEmptyObj(selected_customer) ? false : ((selected_customer) ? true : false))">
                       <label class="form-control-label">{{language_terms['INVOICE_NO']}}</label>
                        <multiselect
                                class="mt-1"
                                :custom-label="invoiceNameWithCode"
                                v-model="selected_invoice"
                                label="name"
                                placeholder="Type to search"
                                open-direction="bottom"
                                :options="report.invoices"
                                :multiple="false"
                                :searchable="true"
                                :loading="loading"
                                :clear-on-select="false"
                                :close-on-select="true"
                                :options-limit="300"
                                :limit="50"
                                :max-height="600"
                                :show-no-results="false"
                                :hide-selected="true"
                                @search-change="asyncFindInvoices"
                                @select="onSelectInvoice"
                            >
                        </multiselect>
                        
                    </b-col>
                    <b-col lg="4">
                        <base-input :label="language_terms['DATE']">
                            <flat-picker
                                slot-scope="{ focus, blur }"
                                @on-open="focus"
                                @on-close="blur"
                                style="background-color: white"
                                class="form-control datepicker"
                                v-model="report.date">
                            </flat-picker>
                        </base-input>
                        
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :lg="report.action ==1 ? 6:12">
                      <base-input :label="language_terms['ACTION_RECOMMENDED']">
                        <el-select v-model="report.action" :placeholder="language_terms['ACTION_RECOMMENDED']" >
                            <el-option
                                v-for="item in activeOptions"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                        </el-select>
                    </base-input>
                    </b-col>
                    <b-col lg="6">
                        <base-input v-model="report.actionOthers" :label="language_terms['OTHERS']" class="mt-4" v-if="report.action ==1 "></base-input>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col :lg="report.returned == 1 ? 6:12">
                        <base-input :label="language_terms['RETURNED_BY']">
                            <el-select v-model="report.returned" :placeholder="language_terms['RETURNED_BY']" >
                                <el-option
                                v-for="item in returnedBy"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                                >
                                </el-option>
                            </el-select>
                        </base-input>
                    </b-col>
                    <b-col lg="6">
                         <base-input v-model="report.returnOthers" :label="language_terms['OTHERS']" class="mt-4" v-if="report.returned == 1" ></base-input>
                    </b-col>
                </b-row>
            </card>
            <!-- {{isEmptyObj(selected_invoice)}} -->
            <card v-if="(isEmptyObj(selected_invoice) ? false : ((selected_invoice) ? true : false)) && (isEmptyObj(selected_customer) ? false : ((selected_customer) ? true : false))">
                <div slot="header">
                    <b-row>
                        <b-col lg="6">
                            <h3 >{{language_terms['PART_ONE_INFO']}}
                            </h3>
                        </b-col>
                    </b-row>
                </div>
                <b-row>
                    <!-- <b-table :items="customerProducts" :fields="prouctTabelFields" head-variant="light" >
                        <template #cell(deleteBtn)="row">
                            <base-button icon type="warning" >
                                <i class="fa fa-trash"></i>
                            </base-button>
                            <base-button icon type="warning" >
                                <i class="fa fa-cog" aria-hidden="true"></i>
                            </base-button>
                        </template>
                    </b-table> -->
                    <el-table :data="customerProducts" style="width: 100%">
                        <el-table-column prop="sno" :label="language_terms['SNO']" :min-width="30">
                            <template slot-scope="scope">
                                <div>{{(scope.$index *1) + 1}}</div>
                            </template>
                        </el-table-column>
                        <el-table-column prop="item_code" :label="language_terms['ITEM_CODE']" :min-width="35">
                            <template slot-scope="scope">
                                {{scope.row.product_code}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="desp_of_product" :label="language_terms['DESP_OF_PRODUCT']">
                            <template slot-scope="scope">
                                {{scope.row.product_name_master}}
                            </template>
                        </el-table-column>

                        <el-table-column prop="invoice_qty" :label="language_terms['INVOICE_QTY']">
                            <template slot-scope="scope">
                                {{scope.row.qty}}{{scope.row.uom}}
                            </template>
                        </el-table-column>
                        <el-table-column prop="unit_price" :label="language_terms['UNIT_PRICE']">
                            <template slot-scope="scope">
                                {{scope.row.unit_price}}
                            </template>
                        </el-table-column>
                         <el-table-column prop="inputQty" :label="language_terms['QTY']">
                            <template slot-scope="scope">
                                <base-input v-model="scope.row.inputQty" type="number" :min="0" :max="scope.row.qty"> </base-input>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column prop="uom" :label="language_terms['UOM']">
                            <template slot-scope="scope">
                                {{scope.row.uom}}
                            </template>
                        </el-table-column> -->
                        <el-table-column prop="amount_total" :label="language_terms['AMOUNT_TOTAL']">
                            <template slot-scope="scope">
                                {{scope.row.inputQty ? (scope.row.unit_price * scope.row.inputQty) : 0}}
                            </template>
                        </el-table-column>
                    </el-table>
                </b-row>
                <hr>
                <b-row class="mt-4">
                    <b-col lg="6">
                        <base-input v-model="report.nonconformance" :label="language_terms['NONCONFORMANCE']"></base-input>
                    </b-col>
                    <b-col lg="6">
                          <base-input v-model="report.instructions" :label="language_terms['INSTRUTIONS']"></base-input>
                    </b-col>
                </b-row>
                 <b-row  class="mt-4">
                    <b-col lg="6">
                        <base-input v-model="report.likelyCause" :label="language_terms['LIKELY_CAUSE']"></base-input>
                    </b-col>
                    <b-col lg="6">
                          <base-input v-model="report.reportedBy" :label="language_terms['REPORTED_BY']"></base-input>
                    </b-col>
                </b-row>
            </card>
        </b-container>
  </div>
</template>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<script>
import moment from "moment";
import {Table,TableColumn,Select, Option } from "element-ui";
import productLookup from "@/components/Autocomplete.vue";
import { mapState } from "vuex";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css'; 
import BaseButton from '../../components/BaseButton.vue';
import axios from "axios";
import { apiRoutes } from "../../apiRoutes";
import { authHeader } from "../../global";
import flatPicker from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import BaseInput from '../../components/Inputs/BaseInput.vue';
import Calendar from '../Calendar/Calendar.vue';
export default {
     components:{
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        flatPicker,
        productLookup,
        Loading,
        BaseButton,
          BaseInput,
          Calendar,
     },
      computed:{
        ...mapState({
            customerProducts:state => state.sales.retrieve_invoice_products,
            language_terms: state => state.languages.language_terms,
            selected_lang: state => state.languages.selected_langauge,
        }),
     },
    data(){
        return{
            loading:false,
           
            returnedBy:[
                {
                    value: "2",
                    label: "Salesman",
                },
                {
                    value: "3",
                    label: "Deliveryman",
                },
                {
                    value: "4",
                    label: "Customer",
                },
                {
                    value: "1",
                    label: "Others",
                },

            ],
            activeOptions: [
                {
                    value: "2",
                    label: "Exchange/Rework",
                },
                {
                    value: "3",
                    label: "Installation Charges",
                },
                {
                    value: "4",
                    label: "Replacement",
                },
                {
                    value: "5",
                    label: "Site Inspection/Repair",
                },
                {
                    value: "6",
                    label: "Order Cancelled/Rejected",
                },
                {
                    value: "7",
                    label: "Repair/Checking",
                },
                {
                    value: "8",
                    label: "Sample Return",
                },
                {
                    value: "9",
                    label: "Credit/Debit Note",
                },
                {
                    value: "10",
                    label: "Sample Return",
                },
                {
                    value: "1",
                    label: "Others",
                },
            ],
                mark:"",
                selected_invoice:{},
                selected_customer:{},
            report:{
                qty:"",
                actionOthers:"",
                returnOthers:"",
                customers:[],
                invoices:[],
                date:"",
                returned:"",
                action:"",
                nonconformance:"",
                instructions:"",
                likelyCause:"",
                reportedBy:"",
                invoiceCode:''

            }

        }  
    },
    methods:{
        isEmptyObj(obj) {
            for(var prop in obj) 
            {
                if(obj.hasOwnProperty(prop)) 
                {
                    return false;
                }
            }
            return JSON.stringify(obj) === JSON.stringify({});
        },
        EmptyObj(obj) {
            for(var prop in obj) 
            {
                if(obj.hasOwnProperty(prop)) 
                {
                    return true;
                }
            }
            return JSON.stringify(obj) === JSON.stringify({});
        },
        async onSelectCustomer(obj)
        {

            if(obj){
                if(obj != this.selected_customer)
                {
                    this.report.invoices = []
                    this.selected_invoice = {}
                    await this.$store.dispatch("sales/setInvoiceProducts", [])
                    
                }
            }
        },
        checkNum(scope){
            if(this.report.qty>scope.row.qty){
                     //console.log(scope)
            }

        },
        customerNameWithCode ({ name, code }) 
        {
            if(name || code)
                return `${name} (${code})`
        },
        invoiceNameWithCode ({ code }) 
        {
            if(code)
                return `${code}`
        },
        async asyncFindCustomer(query) 
        {
            this.isLoading = true;
            let pv = { value: query };
            await axios
                .post(apiRoutes["CUSTOMER_LOOKUP"], pv, authHeader())
                .then((response) => {
                if (response.data.code == 1) {
                   
                    this.report.customers = response.data.data;
                    
                } else {
                    this.report.customers = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({
                            group: "notify",
                            type: "error",
                            text: error.response.data.msg,
                            max: 5,
                            duration: 5000,
                            speed: 300,
                        });
                    } 
                    else 
                    {
                        console.log("Problem ", error);
                    }
                });
        },
        async asyncFindInvoices() 
        {
            // Invoice LookUp
            this.isLoading = true;
            let pv = {"contact_id": {"operator":"=", "value": this.selected_customer.id}}
            await axios
                .post(apiRoutes["FILTER_INVOICES"], pv, authHeader())
                .then((response) => {
                if (response.data.code == 1) {
                    
                    this.report.invoices = response.data.data;
                } 
                else 
                {
                    this.report.invoices = [];
                }

                this.isLoading = false;
                })
                .catch((error) => {
                if (error.response) 
                {
                    Vue.notify({
                            group: "notify",
                            type: "error",
                            text: error.response.data.msg,
                            max: 5,
                            duration: 5000,
                            speed: 300,
                        });
                    } 
                    else 
                    {
                        console.log("Problem ", error);
                    }
                });
        },
         onSelectInvoice(obj)
        {
            console.log(obj)
            console.log(this.selected_invoice)
            if(obj.code)
            {
             this.retrieveProduct(obj.code)
            }
        },
        async retrieveProduct(code)
        {
            this.loading = true
            if(code)
            {
                await this.$store.dispatch("sales/retrieveInvoiceItems", {code:code})
            }
            this.loading=false

        }
    },
    mounted() 
    {
          if(!this.report.date)
      {
        this.report.date = moment().format("YYYY-MM-DD");
      }
    }
}
</script>
